import { Grid, styled } from "@mui/material";

export const RightActionsGrid = styled(Grid)(() => ({
  width: "max-content",
  marginTop: "15px",
}));

export const EmptyText = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "22px",
  color: "#9CA6AF",
  lineHeight: "18px",
  marginBottom: "10px",
}));

export const DisabledText = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "16px",
  color: "#9CA6AF",
  lineHeight: "28px",
  marginBottom: "28px",
}));

export const RequiredFiltersText = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  color: "#9CA6AF",
  lineHeight: "18px",
  marginBottom: "28px",
  width: "430px",
}));
